import { useQuery } from '@apollo/client'
import { reviewsData } from './utils'

interface UseReviews {
  reviewList: ReviewList[] | undefined
  isLoading: boolean
}

interface ReviewItem {
  created_at?: string
  customer_id?: string | null
  detail?: string
  nickname?: string
  rating_votes?: any[]
  review_id: number
  title?: string
}

interface ReviewList {
  items: ReviewItem
}

export const useReviews = (productId: number): UseReviews => {
  const { data, loading } = useQuery(reviewsData, { variables: { productId: productId } })
  const { reviewList } = data || {}

  return {
    reviewList: reviewList?.items ?? undefined,
    isLoading: loading
  }
}
